/**
 * @file Re-exports Value as the entry point of the module.
 */
import Value from "./Value";

export default Value;
